import React from "react";
import { useForm } from "react-hook-form";
// import "bootstrap/dist/css/bootstrap.min.css";

const MembershipForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === "companyLogo") {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    });
   
  };
  const branchesList = [
    { value: "branch1", label: "Branch 1" },
    { value: "branch2", label: "Branch 2" },
  ];
   
  const cityList = [
    { value: "city1", label: "City 1" },
    { value: "city2", label: "City 2" },
  ];
  
  const membershipPlans = [
    { value: "plan1", label: "Basic" },
    { value: "plan2", label: "Premium" },
  ];
  const countryCodes = [
    { value: "+1 🇺🇸 USA", label: "🇺🇸 USA" },
    { value: "+44 🇬🇧 UK", label: "🇬🇧 UK" },
    { value: "+91 🇮🇳 India", label: "🇮🇳 India" },
    { value: "+61 🇦🇺 Australia", label: "🇦🇺 Australia" },
    { value: "+81 🇯🇵 Japan", label: "🇯🇵 Japan" },
  ];
  return (
    <div className="container-fluid bg-white mt-4">
          
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
  <h3>Member Information</h3>
  <div className="col-md-6">
    <label className="form-label">First Name *</label>
    <input className="form-control" {...register("firstName", { required: "First Name is required" })} />
    {errors.firstName && <p className="text-danger">{errors.firstName.message}</p>}
  </div>
  
  <div className="col-md-6">
    <label className="form-label">Last Name *</label>
    <input className="form-control" {...register("lastName", { required: "Last Name is required" })} />
    {errors.lastName && <p className="text-danger">{errors.lastName.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Country *</label>
    <input className="form-control" {...register("country", { required: "Country is required" })} />
    {errors.country && <p className="text-danger">{errors.country.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Birthday *</label>
    <input type="date" className="form-control" {...register("birthday", { required: "Birthday is required" })} />
    {errors.birthday && <p className="text-danger">{errors.birthday.message}</p>}
  </div>

  {/* Mobile Number with Country Code */}
  <div className="col-md-6">
    <label className="form-label">Mobile *</label>
    <div className="input-group">
      <select className="form-select" {...register("countryCodeMobile", { required: "Country code is required" })}>
        {countryCodes.map((code) => (
          <option key={code.value} value={code.value}>{code.label}</option>
        ))}
      </select>
      <input type="tel" className="form-control" {...register("mobile", { required: "Mobile number is required" })} />
    </div>
    {errors.mobile && <p className="text-danger">{errors.mobile.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Job Title *</label>
    <input className="form-control" {...register("jobTitle", { required: "Job Title is required" })} />
    {errors.jobTitle && <p className="text-danger">{errors.jobTitle.message}</p>}
  </div>

  <h3>Company Information</h3>

  <div className="col-md-6">
    <label className="form-label">Company Name *</label>
    <input className="form-control" {...register("companyName", { required: "Company Name is required" })} />
    {errors.companyName && <p className="text-danger">{errors.companyName.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Company Logo *</label>
    <input type="file" className="form-control" {...register("companyLogo", { required: "Company Logo is required" })} />
    {errors.companyLogo && <p className="text-danger">{errors.companyLogo.message}</p>}
  </div>

  {/* Telephone with Country Code */}
  <div className="col-md-6">
    <label className="form-label">Telephone *</label>
    <div className="input-group">
      <select className="form-select" {...register("countryCodeTelephone", { required: "Country code is required" })}>
        {countryCodes.map((code) => (
          <option key={code.value} value={code.value}>{code.value}</option>
        ))}
      </select>
      <input type="tel" className="form-control" {...register("telephone", { required: "Telephone is required" })} />
    </div>
    {errors.telephone && <p className="text-danger">{errors.telephone.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Branches/Locations *</label>
    <select className="form-control" {...register("branches", { required: "Branch/Location is required" })}>
      <option value="">Select Branch/Location</option>
      {branchesList.map((branch) => (
        <option key={branch.value} value={branch.value}>{branch.label}</option>
      ))}
    </select>
    {errors.branches && <p className="text-danger">{errors.branches.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">City *</label>
    <select className="form-control" {...register("city", { required: "City is required" })}>
      <option value="">Select City</option>
      {cityList.map((city) => (
        <option key={city.value} value={city.value}>{city.label}</option>
      ))}
    </select>
    {errors.city && <p className="text-danger">{errors.city.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Number Of Employees *</label>
    <input type="number" className="form-control" {...register("numEmployees", { required: "Number of Employees is required" })} />
    {errors.numEmployees && <p className="text-danger">{errors.numEmployees.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Email *</label>
    <input type="email" className="form-control" {...register("email", { required: "Email is required" })} />
    {errors.email && <p className="text-danger">{errors.email.message}</p>}
  </div>

  <div className="col-md-6">
    <label className="form-label">Company Establishment Date *</label>
    <input type="date" className="form-control" {...register("companyEstablishmentDate", { required: "Establishment Date is required" })} />
    {errors.companyEstablishmentDate && <p className="text-danger">{errors.companyEstablishmentDate.message}</p>}
  </div>

  <div className="col-md-12">
    <label className="form-label">Membership Plan *</label>
    <select className="form-control" {...register("membershipPlan", { required: "Membership Plan is required" })}>
      <option value="">Select Membership Plan</option>
      {membershipPlans.map((plan) => (
        <option key={plan.value} value={plan.value}>{plan.label}</option>
      ))}
    </select>
    {errors.membershipPlan && <p className="text-danger">{errors.membershipPlan.message}</p>}
  </div>

  <div className="col-md-12">
    <label className="form-label">Company Address *</label>
    <textarea className="form-control" rows="4" {...register("companyAddress", { required: "Company Address is required" })}></textarea>
    {errors.companyAddress && <p className="text-danger">{errors.companyAddress.message}</p>}
  </div>

  <div className="col-md-12">
    <label className="form-label">About Your Company *</label>
    <textarea className="form-control" rows="4" {...register("aboutCompany", { required: "About Your Company is required" })}></textarea>
    {errors.aboutCompany && <p className="text-danger">{errors.aboutCompany.message}</p>}
  </div>

  <div className="col-md-12 mt-3">
    <button type="submit" className="btn btn-primary">Submit</button>
  </div>

 
</form>

    </div>
  );
};

export default MembershipForm;
